import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "flag-check" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 23.25,
			x2: .75,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,20.293l3.154-.97a9.61,9.61,0,0,1,7.864,1,9.615,9.615,0,0,0,7.679,1.056l2.987-.853a1.126,1.126,0,0,0,.816-1.082V3.637a1.126,1.126,0,0,0-1.434-1.082l-2.369.677a9.615,9.615,0,0,1-7.679-1.056,9.61,9.61,0,0,0-7.864-1L.75,2.145"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "16.5 8.25 12 14.25 9 11.25"
		})
	]
});
export default SvgFlagCheck;
